import React, { FC } from "react";

import { Outlet } from "react-router-dom";

import { Loader2 as Loader } from "components/Loader";

import { DebugProvider } from "./pages/Template";
import { TitleProvider } from "./Title";

/**
 * Permet de définir si le navigateur est un mobile
 * La valeur est calculé par la taille de la fenêtre en largeur
 */
function isMobileDevice() {
  return window.matchMedia("(min-width: 764px)").matches ? false : true;
}

export const MobileDeviceContext = React.createContext(false);

/**
 * Composant parent de l'application
 * C'est ce composant qui détermine les différentes URL de l'application
 *
 * @class App
 * @extends {Component<AppAllProps, { isMobile: boolean }>}
 */
const App: FC = () => {
  const [isMobile, setIsMobile] = React.useState(() => {
    return isMobileDevice();
  });

  React.useEffect(() => {
    function resizeWindow() {
      setIsMobile(isMobileDevice());
    }

    window.addEventListener("resize", resizeWindow);
    return function cleanup() {
      window.removeEventListener("resize", resizeWindow);
    };
  }, [isMobile, setIsMobile]);

  return (
    <MobileDeviceContext.Provider value={isMobile}>
      <TitleProvider>
        <DebugProvider>
          <React.Suspense fallback={<Loader />}>
            <Outlet />
          </React.Suspense>
        </DebugProvider>
      </TitleProvider>
    </MobileDeviceContext.Provider>
  );
};

export default App;
